import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ReturnDashboardItemSettings } from "src/app/models/dashboard/return-dashboard-item-settings";
import { DashboardService } from "src/app/services/dashboard/dashboard.service";

@Injectable()
export class DashboardItemSettingsResolver  {

    constructor(private dashboardService: DashboardService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ReturnDashboardItemSettings>> {
        const response = this.dashboardService.getDashboardItemSettings()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload.dashboardItemSettings;
                }
                else {
                    return <ReturnDashboardItemSettings>{
                        sourceScopeOptions: [],
                        userScopeOptions: [],
                        summarizationTypeOptions: [],
                        typeScopeOptions: [],
                        timeScopeOptions: []
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ReturnDashboardItemSettings>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}